/** set types */
export const GET_LEADS_LIST = "GET_LEADS_LIST";
/** add types */
export const ADD_LEADS_LIST = "ADD_LEADS_LIST";
/** update types */
export const UPDATE_LEADS_LIST = "UPDATE_LEADS_LIST";
/** delete types */
export const DELETE_LEADS_LIST = "DELETE_LEADS_LIST";
